import { fromLonLat } from 'ol/proj';

import DrawingUtils from '../utils/DrawingUtils';

/**
 * Goto 마커 및 경로 관리 Feature
 */
class GotoFeature {
  constructor(createOverlay, map) {
    this.createOverlay = createOverlay;
    this.map = map;
    this.gotos = {};
  }

  /**
   * Goto 마커 추가 또는 업데이트
   * @param {string} robotId - 로봇 ID
   * @param {Object} position - { lat, lng } 좌표
   * @param {string} color - 마커 색상
   */
  addMarker(robotId, position, color) {
    // 기존 Goto Marker
    if (this.gotos[robotId]) {
      this.gotos[robotId].position = position;
      this.gotos[robotId].marker.setPosition(fromLonLat([position.lng, position.lat]));
    }
    // 신규 Goto Marker
    else {
      this.gotos[robotId] = {
        position,
        marker: DrawingUtils.drawMarker(this.createOverlay, this.map, position, 'G', color),
      };
    }
  }

  /**
   * Goto 경로 추가 또는 업데이트
   * @param {string} robotId - 로봇 ID
   * @param {Object} position - 현재 로봇 위치 { lat, lng }
   * @param {string} color - 경로 색상
   */
  addPath(robotId, position, color) {
    // Goto 미정의 시
    if (!this.gotos[robotId]) return;

    // 두 점 간 직선 정의
    const from = fromLonLat([position.lng, position.lat]);
    const to = this.gotos[robotId].marker.getPosition();
    const path = [from, to];

    // 기존 경로
    if (this.gotos[robotId].path) {
      const feature = this.gotos[robotId].path.getSource().getFeatures()[0];
      feature.getGeometry().setCoordinates(path);
    }
    // 신규 경로
    else {
      this.gotos[robotId].path = DrawingUtils.drawPaths(this.map, [path], color);
    }
  }

  /**
   * Goto 마커 및 경로 제거
   * @param {string} robotId - 로봇 ID
   */
  remove(robotId) {
    if (!this.gotos[robotId]) return;

    this.map.removeOverlay(this.gotos[robotId].marker);
    if (this.gotos[robotId].path) {
      this.map.removeLayer(this.gotos[robotId].path);
    }
    delete this.gotos[robotId];
  }

  /**
   * Goto 데이터 가져오기
   * @param {string} robotId - 로봇 ID
   * @returns {Object|undefined} Goto 데이터
   */
  get(robotId) {
    return this.gotos[robotId];
  }
}

export default GotoFeature;
